import request from '@/utils/request';

const baseURLAdmin = process.env.VUE_APP_ADMIN;
const baseUserURL = process.env.VUE_APP_USER; // /user
/**
 * 操作指南——修改
 */
export const operationGuideEdit = (data) => {
  return request({
    url: '/operationGuide/update',
    method: 'put',
    data,
    baseURL: baseURLAdmin
  });
};

/**
 * 操作指南——新增
 */
export const operationGuideAdd = (data) => {
  return request({
    url: '/operationGuide/add',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};

/**
 * 操作指南——分页
 */
export const operationGuidePage = (data) => {
  return request({
    url: '/operationGuide/page',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};

/**
 * 资源管理 --- 获取已有资源
 * @param query
 * @returns
 */
export const getExistenceResources = (query) => {
  return request.post('/resource/page', query);
};
/**
 * 添加资源
 */
export const addResource = (query) => {
  return request.post('/user/resource/add', query);
};
/**
 * 删除资源
 */
export const deleteResource = (query) => {
  return request.post('/user/resource/delete?resourceId=' + query);
};
/**
 * 修改资源
 */
export const changeResource = (query) => {
  return request.post('/user/resource/edit', query);
};
/**
 * 获取资源标签列表
 */
export const getResourceTagList = (query) => {
  return request.post('/user/resourceTag/page', query);
};
/**
 * 新增资源标签
 */
export const addResourceTag = (query) => {
  return request.post('/user/resourceTag/add', query);
};
/**
 * 校验标签名称重复
 */
export const checkResourceTagName = (query) => {
  return request.post('/user/resourceTag/checkName?name=' + query);
};
/**
 * 资源标签修改
 */
export const editResourceTag = (query) => {
  return request.post('/user/resourceTag/edit', query);
};
/**
 * 资源标签删除
 */
export const deleteResourceTag = (query) => {
  return request.post('/user/resourceTag/delete?id=' + query);
};

/**
 * 资源导出审核
 */
export const apiFileExportVerify = (ids, verifyId, verifyName) => {
  return request({
    url: `/fileExport/verify/${ids}/${verifyId}/${verifyName}`,
    method: 'PUT'
  });
};

/**
 * 资源导出列表
 */
export const apiFileExportPage = (data) => {
  return request({
    method: 'post',
    data,
    url: '/fileExport/page',
    baseURL: baseURLAdmin
  });
};
/**
 * 资源导出列表————取消任务
 */
export const cancelFileTask = (data) => {
  return request({
    url: '/excelTask/cancel?id=' + data,
    method: 'get',
    baseURL: baseURLAdmin
  });
};
/**
 * 资源导出列表
 */
export const apiFileTaskPage = (data) => {
  return request({
    url: '/excelTask/page',
    method: 'post',
    data: data,
    isLoading: false,
    baseURL: baseURLAdmin
  });
};
export const apiFileTaskCancel = (data) => {
  return request({
    url: '/excelTask/cancel?id=' + data,
    method: 'get',
    baseURL: baseURLAdmin
  });
};

// 消息记录管理
export const apiMessageSendRecordPage = (data) => {
  return request.post('/user/messageSendRecord/page', data);
};

// 发送短信
export const apiMessageSendRecordSendSms = (data) => {
  return request.post('/user/messageSendRecord/sendSms', data);
};

// 资源管理page查询
export const appManagePage = (data) => {
  return request({
    method: 'post',
    data,
    url: '/app/manage/page',
    baseURL: baseURLAdmin
  });
};
// 资源管理——修改
export const appManageUpdate = (data) => {
  return request({
    method: 'post',
    data,
    url: '/app/manage/update',
    baseURL: baseURLAdmin
  });
};
// 资源管理——新增
export const appManageAdd = (data) => {
  return request.post('/app/manage/add', data);
};
// 签收配置分页查询
export const restrictionPage = (data) => {
  // return request.post('/sign/restriction/page', data);
  return request({
    url: `/sign/restriction/page`,
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// 根据州获取网点
export const getSiteByState = (data) => {
  // return request.post(`/sign/restriction/getSiteByState`, data);
  return request({
    url: `/sign/restriction/getSiteByState`,
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// 获取启用的短信模板
export const getOpenTemplate = () => {
  // return request.get('/smsTemplate/getOpenTemplate');
  return request({
    url: `/smsTemplate/getOpenTemplate`,
    method: 'get',
    baseURL: baseURLAdmin
  });
};
// 新增签收配置
export const restrictionadd = (data) => {
  return request.post('/sign/restriction/add', data);
};
// 签收配置启用停用
export const restrictionisOpened = (data) => {
  return request.post('/sign/restriction/isOpened', data);
};
// 解除限制分页查询
export const signRescissionpage = (data) => {
  // return request.post('/signRescission/page', data);
  return request({
    url: `/signRescission/page`,
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// 查询服务商账号
export const signRescissiongetPmUserList = (data) => {
  // return request.post('/signRescission/getPmUserList', data);
  return request({
    url: `/pmUser/getPmUserList`,
    method: 'post',
    data,
    baseURL: baseUserURL
  });
};
// 新增  解除限制
export const signRescissionadd = (data) => {
  return request.post('/signRescission/add', data);
};
// 删除  解除限制
export const signRescissiondeleted = (data) => {
  return request.post(`/signRescission/deleted`, data);
};
// 导出  解除限制
export const signRescissionexport = (data) => {
  return request.post('/signRescission/export', data);
};
// 编辑 签收配置
export const restrictionupdate = (data) => {
  // return request.post('/sign/restriction/update', data);
  return request({
    url: `/sign/restriction/update`,
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// 签收配置启用停用
export const batchIsOpened = (data) => {
  return request.post('/sign/restriction/batchIsOpened', data);
};
// 短信配置启用停用
export const smsConfigBatchEdit = (data) => {
  return request.post('/smsConfig/batchEdit', data);
};
// 新增  解除限制 运单号
export const signRescissionreleaseWayBill = (data) => {
  return request.post('/signRescission/releaseWayBill', data);
};
// 签收配置分页查询
export const getUserList = (data) => {
  // return request.post('/sign/restriction/userList', data);
  return request({
    url: `/sign/restriction/userList`,
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// 问题件配置  分页查询
export const getproblemCongfigPage = (data) => {
  // return request.post('/problemType/page', data);
  return request({
    url: `/problemType/page`,
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// 问题件配置  状态
export const getproblemChangeStatus = (data) => {
  // return request.post('/problemType/changeStatus', data);
  return request({
    url: `/problemType/changeStatus`,
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// 问题件配置  添加问题件配置
export const getproblemChangeAdd = (data) => {
  // return request.post('/problemType/add', data);
  return request({
    url: `/problemType/add`,
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// 问题件配置  修改问题件配置
export const problemChangeUpdate = (data) => {
  // return request.post('/problemType/update', data);
  return request({
    url: `/problemType/update`,
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// 问题件配置  查询问题件原因分类
export const getProblemReason = () => {
  // return request.get('/problemType/getProblemReason');
  return request({
    url: `/problemType/getProblemReason`,
    method: 'get',
    baseURL: baseURLAdmin
  });
};
// 问题件配置  查询一级问题件列表
export const getParentProblemType = () => {
  // return request.get('/problemType/getParentProblemType');
  return request({
    url: `/problemType/getParentProblemType`,
    method: 'get',
    baseURL: baseURLAdmin
  });
};
// 导出问题件配置
export const getproblemExport = (data) => {
  // return request.post('/problemType/export', data);
  return request({
    url: `/problemType/export`,
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// 签收限制导出
export const signLimitExport = (data) => {
  return request({
    method: 'post',
    data,
    url: '/sign/restriction/export',
    baseURL: baseURLAdmin
  });
};
// 登记问题件限制配置分页查询
export const getProblemLimitPage = (data) => {
  return request({
    method: 'post',
    data,
    url: '/problem/restriction/page',
    baseURL: baseURLAdmin
  });
};
// 添加登记问题件限制配置
export const addProblemLimit = (data) => {
  return request({
    method: 'post',
    data,
    url: '/problem/restriction/add',
    baseURL: baseURLAdmin
  });
};
// 修改登记问题件限制配置
export const updateProblemLimit = (data) => {
  return request({
    method: 'post',
    data,
    url: '/problem/restriction/update',
    baseURL: baseURLAdmin
  });
};
// 获取登记问题件限制配置的商户
export const getProblemLimitUserList = (data) => {
  return request({
    method: 'post',
    data,
    url: '/problem/restriction/queryMerChantName',
    baseURL: baseURLAdmin
  });
};
// 获取登记问题件限制配置的账号数据 - 服务商账号/user/pmUser/queryPage
export const getProblemLimitPmUserList = (data) => {
  return request({
    method: 'post',
    data,
    url: '/pmUser/queryPage',
    baseURL: baseUserURL
  });
};
// 批量启用/停用
export const batchIsOpenedProblemLimit = (data) => {
  return request({
    method: 'post',
    data,
    url: '/problem/restriction/batchChangeStatus',
    baseURL: baseURLAdmin
  });
};
// 登记问题件限制配置导出
export const exportProblemLimit = (data) => {
  return request({
    method: 'post',
    data,
    url: '/problem/restriction/export',
    baseURL: baseURLAdmin
  });
};
// 登记问题件限制解除分页查询
export const getProblemLimitReleasePage = (data) => {
  return request({
    method: 'post',
    data,
    url: '/problem/unrestrict/page',
    baseURL: baseURLAdmin
  });
};
// 新增登记问题件限制解除
export const addProblemLimitRelease = (data) => {
  return request({
    method: 'post',
    data,
    url: '/problem/unrestrict/add',
    baseURL: baseURLAdmin
  });
};
// 导出登记问题件限制解除
export const exportProblemLimitRelease = (data) => {
  return request({
    method: 'post',
    data,
    url: '/problem/unrestrict/export',
    baseURL: baseURLAdmin
  });
};
// 删除登记问题件限制解除
export const deleteProblemLimitRelease = (data) => {
  return request({
    method: 'post',
    data,
    url: '/problem/unrestrict/del',
    baseURL: baseURLAdmin
  });
};
